"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _AdobeTargetColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeTargetColorLight"));

var _AdobeCampaignColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeCampaignColorLight"));

var _AdobeAnalyticsColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeAnalyticsColorLight"));

var _AdobeExperienceManagerColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeExperienceManagerColorLight"));

var _AdobeSocialColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeSocialColorLight"));

var _AdobeAudienceManagerColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeAudienceManagerColorLight"));

var _AdobePrimetimeColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobePrimetimeColorLight"));

var _AdobeExperienceCloud = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeExperienceCloud"));

var _AdobeAdvertisingCloud = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeAdvertisingCloud"));

var _Icon = _interopRequireDefault(require("@react/react-spectrum/Icon"));

/************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
// For now the Magento will be shown by svg
// TODO update the icon with spectrum Icon
var tempIcon = {
  MagentoCommerceColor: _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M12,1.2c1.5,0,2.9,0.3,4.2,0.8c1.3,0.5,2.4,1.3,3.4,2.3c1,1,1.8,2.1,2.3,3.4c0.6,1.3,0.8,2.7,0.8,4.2s-0.3,2.9-0.8,4.2c-0.5,1.3-1.3,2.4-2.3,3.4c-1,1-2.1,1.8-3.4,2.3c-1.3,0.6-2.7,0.8-4.2,0.8s-2.9-0.3-4.2-0.8c-1.3-0.5-2.4-1.3-3.4-2.3c-1-1-1.8-2.1-2.3-3.4c-0.6-1.3-0.8-2.7-0.8-4.2s0.3-2.9,0.8-4.2c0.5-1.3,1.3-2.4,2.3-3.4c1-1,2.1-1.8,3.4-2.3C9.1,1.5,10.5,1.2,12,1.2 M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0L12,0z",
    fill: "#FF661A"
  }), _react.default.createElement("polygon", {
    fill: "#FFDFDD",
    points: "12,4.1 5.2,8.1 5.2,15.9 7.1,17 7.1,9.2 12,6.4 16.9,9.2 16.9,17 18.8,15.9 18.8,8.1"
  }), _react.default.createElement("polygon", {
    fill: "#FFDFDD",
    points: "13,17 12,17.6 11,17.1 11,9.2 9.1,10.3 9.1,18.2 12,19.9 14.9,18.2 14.9,10.3 13,9.2"
  }))
};
var MagentoCommerceColor = tempIcon.MagentoCommerceColor;
var iconMapping = {
  "Adobe Target": _react.default.createElement(_AdobeTargetColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Adobe Campaign": _react.default.createElement(_AdobeCampaignColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Adobe Analytics": _react.default.createElement(_AdobeAnalyticsColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Adobe Experience Manager": _react.default.createElement(_AdobeExperienceManagerColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Experience Manager": _react.default.createElement(_AdobeExperienceManagerColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Adobe Social": _react.default.createElement(_AdobeSocialColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Adobe Audience Manager": _react.default.createElement(_AdobeAudienceManagerColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Adobe Primetime": _react.default.createElement(_AdobePrimetimeColorLight.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Cross-Cloud Capabilities": _react.default.createElement(_AdobeExperienceCloud.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  "Experience Cloud": _react.default.createElement(_AdobeExperienceCloud.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }),
  // TODO update the icon with spectrum Icon
  "Magento Commerce": _react.default.createElement(_Icon.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }, MagentoCommerceColor),
  //added this for announcement mapping 
  "Magento Commerce Cloud": _react.default.createElement(_Icon.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  }, MagentoCommerceColor),
  "Adobe Advertising Cloud": _react.default.createElement(_AdobeAdvertisingCloud.default, {
    size: "L",
    className: "pulse-announcement-solution-icon"
  })
};

var SolutionIcon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SolutionIcon, _Component);

  function SolutionIcon() {
    (0, _classCallCheck2.default)(this, SolutionIcon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SolutionIcon).apply(this, arguments));
  }

  (0, _createClass2.default)(SolutionIcon, [{
    key: "render",
    value: function render() {
      if (iconMapping[this.props.product]) {
        return _react.default.createElement("div", null, iconMapping[this.props.product]);
      }

      return _react.default.createElement("div", null, iconMapping["Cross-Cloud Capabilities"]);
    }
  }]);
  return SolutionIcon;
}(_react.Component);

exports.default = SolutionIcon;